/**
 * True only for real WAHA-backed Channel::Api inboxes.
 * Generic API channels and official WhatsApp Cloud must not get remote edit.
 * @param {Object|null|undefined} inbox
 * @returns {boolean}
 */
export function isWahaApiInbox(inbox) {
  if (!inbox || typeof inbox !== 'object') return false;
  if (inbox.channel_type !== 'Channel::Api') return false;
  return Boolean(inbox.additional_attributes?.waha_session_name);
}
